/**
 * Editorial Menu Mobile Accordion
 * Handles accordion functionality for editorial menus in mobile drawer
 * Does NOT interfere with existing submenu system
 */

(function() {
  'use strict';

  class EditorialMenuMobile {
    constructor() {
      this.selectors = {
        container: '.m-mega-editorial-mobile',
        toggle: '.m-mega-editorial-mobile__toggle',
        group: '.m-mega-editorial-mobile__group',
        content: '.m-mega-editorial-mobile__content',
      };
      
      this.classes = {
        open: 'is-open',
      };
      
      this.initialized = false;
      this.init();
    }

    init() {
      // Wait for DOM to be fully ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.attachEvents());
      } else {
        this.attachEvents();
      }

      // Reinitialize when drawer opens
      this.observeDrawer();
    }

    attachEvents() {
      if (this.initialized) return;
      
      // Use event delegation on the document
      document.addEventListener('click', (e) => {
        // Find if click is on or inside a toggle button
        const toggle = e.target.closest(this.selectors.toggle);
        if (!toggle) return;

        // Find parent group
        const group = toggle.closest(this.selectors.group);
        if (!group) return;

        // Check if this is inside the editorial mobile menu
        const editorialMenu = group.closest(this.selectors.container);
        if (!editorialMenu) return;

        // Prevent default behavior
        e.preventDefault();
        e.stopPropagation();

        // Toggle the accordion
        this.toggleGroup(group, toggle);
      }, false); // Don't use capture phase to avoid conflicts

      this.initialized = true;
      console.log('Editorial Menu Mobile: Events attached');
    }

    toggleGroup(group, toggle) {
      const isOpen = group.classList.contains(this.classes.open);
      
      console.log('Editorial Menu Mobile: Toggling', isOpen ? 'close' : 'open');
      
      if (isOpen) {
        this.closeGroup(group, toggle);
      } else {
        this.openGroup(group, toggle);
      }
    }

    openGroup(group, toggle) {
      const content = group.querySelector(this.selectors.content);
      if (!content) return;

      // Add open class
      group.classList.add(this.classes.open);
      toggle.setAttribute('aria-expanded', 'true');
      
      // Calculate and set height
      const scrollHeight = content.scrollHeight;
      content.style.maxHeight = scrollHeight + 'px';
      
      console.log('Editorial Menu Mobile: Opened, height:', scrollHeight);
    }

    closeGroup(group, toggle) {
      const content = group.querySelector(this.selectors.content);
      if (!content) return;

      // Remove open class
      group.classList.remove(this.classes.open);
      toggle.setAttribute('aria-expanded', 'false');
      
      // Reset height
      content.style.maxHeight = '0';
      
      console.log('Editorial Menu Mobile: Closed');
    }

    observeDrawer() {
      // Wait for drawer to exist
      const checkDrawer = () => {
        const menuDrawer = document.querySelector('#m-menu-drawer');
        if (!menuDrawer) {
          setTimeout(checkDrawer, 100);
          return;
        }

        // Observe drawer state changes
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const isOpen = menuDrawer.classList.contains('open');
              if (isOpen) {
                // Drawer opened, recalculate heights
                setTimeout(() => this.recalculateHeights(), 300);
              }
            }
          });
        });
        
        observer.observe(menuDrawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      };

      checkDrawer();
    }

    recalculateHeights() {
      // Recalculate all open accordions
      const openGroups = document.querySelectorAll(this.selectors.group + '.' + this.classes.open);
      openGroups.forEach(group => {
        const content = group.querySelector(this.selectors.content);
        if (content) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
      
      if (openGroups.length > 0) {
        console.log('Editorial Menu Mobile: Recalculated', openGroups.length, 'open groups');
      }
    }

    closeAll() {
      const groups = document.querySelectorAll(this.selectors.group);
      groups.forEach(group => {
        const toggle = group.querySelector(this.selectors.toggle);
        if (toggle && group.classList.contains(this.classes.open)) {
          this.closeGroup(group, toggle);
        }
      });
    }
  }

  // Initialize once
  let instance = null;
  
  function initEditorialMenu() {
    if (!instance) {
      instance = new EditorialMenuMobile();
      console.log('Editorial Menu Mobile: Initialized');
    }
  }

  // Initialize
  initEditorialMenu();

  // Reinitialize in Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail && event.detail.sectionId) {
        console.log('Editorial Menu Mobile: Theme editor reload');
        instance = null;
        initEditorialMenu();
      }
    });
  }

  // Expose to window for debugging
  window.EditorialMenuMobile = EditorialMenuMobile;
})();